import { RichTextContent } from '@etg/wings';
import { useProductCardContext } from '../../context/ProductCardContext';
import SmallCardReadMore from '../small-card-layout/SmallCardReadMore';
import { jsx as _jsx } from "react/jsx-runtime";
const ViSmallCardReadMore = ({
  className
}) => {
  const {
    extraProps,
    productName
  } = useProductCardContext();
  const viReadMorePrefix = extraProps === null || extraProps === void 0 ? void 0 : extraProps.viReadMorePrefix;
  return /*#__PURE__*/_jsx(SmallCardReadMore, {
    className: className,
    children: viReadMorePrefix ? /*#__PURE__*/_jsx(RichTextContent, {
      id: `${productName}-viReadMorePrefix`,
      children: viReadMorePrefix
    }) : undefined
  });
};
export default ViSmallCardReadMore;
//# sourceMappingURL=ViSmallCardReadMore.js.map